import { render } from "./authNavbar.vue?vue&type=template&id=427e8d7e&scoped=true&ts=true"
import script from "./authNavbar.vue?vue&type=script&lang=ts"
export * from "./authNavbar.vue?vue&type=script&lang=ts"

import "./authNavbar.vue?vue&type=style&index=0&id=427e8d7e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427e8d7e"]])

export default __exports__